import * as t from './actionTypes';

export const fetchCatalogFieldTypesRequest = (tableName: string) => ({
  type: t.FETCH_CATALOG_FIELD_TYPES_REQUEST,
  tableName,
});

export const fetchCatalogFieldTypesResponse = (
  tableName: string,
  fieldTypes: Record<string, any>,
) => ({
  type: t.FETCH_CATALOG_FIELD_TYPES_RESPONSE,
  tableName,
  fieldTypes,
});

export const fetchCatalogFieldTypesError = (error: string) => ({
  type: t.FETCH_CATALOG_FIELD_TYPES_ERROR,
  error,
});

export const updateCatalogFieldTypesRequest = (
  tableName: string,
  fieldTypes: Record<string, any>,
) => ({
  type: t.UPDATE_CATALOG_FIELD_TYPES_REQUEST,
  tableName,
  fieldTypes,
});

export const updateCatalogFieldTypesResponse = (
  tableName: string,
  fieldTypes: Record<string, any>,
) => ({
  type: t.UPDATE_CATALOG_FIELD_TYPES_RESPONSE,
  tableName,
  fieldTypes,
});

export const updateCatalogFieldTypesError = (error: string) => ({
  type: t.UPDATE_CATALOG_FIELD_TYPES_ERROR,
  error,
});

export const updateAndFetchFieldTypes = (tableName: string, fieldTypes: Record<string, any>) => ({
  type: t.UPDATE_AND_FETCH_CATALOG_FIELD_TYPES,
  tableName,
  fieldTypes,
});

export const updateAndFetchFieldTypesError = (error: string) => ({
  type: t.UPDATE_AND_FETCH_CATALOG_FIELD_TYPES_ERROR,
  error,
});
